import { CubeTimeDimensionGranularity, Weekdays } from "../../../enum/cube-schema.enum";
import { IWorkingSessionsAnalyticsActivityScoresEnumV2 } from "../../../enum/working-sessions-analytics-activity.enum";
import { CubeConfigDto } from "../../common/request/cube-config.dto";

export interface QueryScoreTimeSeriesV2RequestParamsDto {
    startDate: string;
    endDate: string;
    granularity: CubeTimeDimensionGranularity;
    weekday?: Weekdays;
    score: IWorkingSessionsAnalyticsActivityScoresEnumV2;
}